module.exports = __webpack_public_path__ + "static/media/lights_non_food.f14f98a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/nonfood-store/lights_non_food.png
// module id = 480
// module chunks = 0